/* mm-cookie: (1) esconde o icone flutuante de cookies (Pandectes) no celular e adiciona link "Cookie settings" no rodape; (2) sobe a seta "voltar ao topo" quando a barra fixa de Add to cart esta visivel (revert: remover este arquivo e a linha no snippets/meta-tags.liquid) */
(function(){
  var CSS='@media (max-width:749px){.widget{display:none !important}}';
  function widget(){var h=document.querySelector('pandectes-cmp');var r=h&&h.shadowRoot;return r?r.querySelector('.widget'):null}
  function hide(){var h=document.querySelector('pandectes-cmp');var r=h&&h.shadowRoot;if(!r)return;if(!r.querySelector('#mm-cmp-hide')){var s=document.createElement('style');s.id='mm-cmp-hide';s.textContent=CSS;r.appendChild(s)}}
  function link(){
    if(document.querySelector('.mm-cookie-link'))return;
    var a=document.querySelector('footer a[href*="/policies/privacy-policy"]');
    var li=a&&a.closest('li');if(!li||!li.parentNode)return;
    var n=li.cloneNode(true);var x=n.querySelector('a');
    x.href='#';x.textContent='Cookie settings';x.className=a.className+' mm-cookie-link';x.removeAttribute('target');x.removeAttribute('rel');
    x.addEventListener('click',function(e){e.preventDefault();var w=widget();if(w){w.click();return}
      try{if(window.Shopify&&Shopify.customerPrivacy&&Shopify.customerPrivacy.showPreferences){Shopify.customerPrivacy.showPreferences()}}catch(err){}});
    li.parentNode.appendChild(n);
  }
  /* seta de voltar ao topo acima da barra fixa de Add to cart (so quando a barra esta visivel) */
  function arrow(){
    var b=document.querySelector('.scroll-to-top-btn'),s=document.querySelector('.sticky-atc');
    if(!b||!s)return;
    var shown=s.getAttribute('data-after-scroll')!=='true'&&getComputedStyle(s).display!=='none';
    if(shown){b.style.setProperty('bottom','calc(var(--offset-y) + '+(s.offsetHeight+4)+'px)','important')}
    else{b.style.removeProperty('bottom')}
  }
  var arrowT;
  function arrowSoon(){arrow();clearTimeout(arrowT);arrowT=setTimeout(arrow,220)}
  window.addEventListener('scroll',arrowSoon,{passive:true});
  window.addEventListener('resize',arrowSoon);
  var tries=0;
  function tick(){hide();link();arrow();if(++tries>=60)clearInterval(t)}
  var t=setInterval(tick,500);
  document.addEventListener('DOMContentLoaded',function(){tick();var s=document.querySelector('.sticky-atc');if(s&&window.MutationObserver){new MutationObserver(arrowSoon).observe(s,{attributes:true,attributeFilter:['data-after-scroll','class','style']})}});
})();
